import { Component, inject, input } from '@angular/core';
import { ContentfulService } from '@core/services/contentful.service';
import { LeadMagnetActiveCampaignComponent } from '@features/lead-magnet/components/lead-magnet-active-campaign/lead-magnet-active-campaign.component';
import { derivedAsync } from 'ngxtension/derived-async';

@Component({
    selector: 'app-lead-magnet-builder-io-active-campaign',
    standalone: true,
    imports: [LeadMagnetActiveCampaignComponent],
    templateUrl: './lead-magnet-builder-io-active-campaign.component.html',
    styles: ``,
})
export class LeadMagnetBuilderIoActiveCampaignComponent {
    id = input.required<string>();

    private contentfulService = inject(ContentfulService);

    entry = derivedAsync(() => this.contentfulService.leadMagnet(this.id()));
}
